import * as React from "react";
export class Gamefield extends React.Component {
    render() {
        return (React.createElement("div", { className: "rj-baseball-scoreboard-gamefield" },
            React.createElement("div", { className: "rj-baseball-scoreboard-gamefield-heading" }, this.props.heading),
            React.createElement("div", { className: "rj-baseball-scoreboard-gamefield-content" },
                React.createElement("div", { className: "rj-baseball-scoreboard-gamefield-diamond" }, this.props.children))));
    }
}
//# sourceMappingURL=Gamefield.js.map